import React from "react";

const MetricCards = ({ metrics = [] }) => {
  return (
    <div className="grid three">
      {metrics.map((metric) => (
        <div key={metric.label} className="panel">
          <div className="card-title">{metric.label}</div>
          <div className="card-value">
            {metric.value} {metric.unit}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricCards;
